import * as React from 'react'
import DividerComp from '../../components/DividerComp/DividerComp'

import type { ImageViewModel } from '../../view-models/ImageViewModel'
import type { OptionAccordionsViewModel } from '../../view-models/OptionAccordionsViewModel'
import styles from './accordion-style.css'
import Rte from '@/components/Rte/Rte'
import Image from '@/components/Image/Image'
import VideoPlayer from '@/components/VideoPlayer/VideoPlayer'
import Plus from '@/icons/Plus'

export type AccordionProps = {
  items: Array<OptionAccordionsViewModel>
  title: string
  avatar?: ImageViewModel
  icon?: string
  id?: string

  /*will be sent by backend for the Anchor Points*/
  hideDivider?: boolean
}

const AccordionItem = ({ items, hideDivider }: AccordionProps) => {
  const onSummaryClick = (e) => {
    e.preventDefault()
    const detailsElement = e.target.closest('details')
    detailsElement.open = !detailsElement.open

    if (detailsElement.open) {
      window.scrollTo({
        top: detailsElement.offsetTop,
        behavior: 'smooth',
      })
    }
  }

  return (
    <>
      {items.map((item, index) => (
        /*If the name is the same for all accordions, you can only have one open at the same time.*/
        <details key={item.title} name={'accordion-item'}>
          <summary onClick={onSummaryClick}>
            {item.title}
            <Plus className={styles.icon} />
          </summary>
          <div className={styles.accordionContent}>
            {item?.text && <Rte source={item?.text} cta={item?.cta} />}
            {item.image && (
              <div className={styles.imageWrapper}>
                <Image {...item?.image} contain className={styles.image} />
              </div>
            )}
            {item?.video && (
              <VideoPlayer {...item?.video} aspectRatio={9 / 16} />
            )}
          </div>
        </details>
      ))}
      {!hideDivider && <DividerComp />}
    </>
  )
}

export default AccordionItem
